import React, { useState, useCallback } from "react";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import { useHistory, useLocation } from "react-router-dom";

import { connect } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "../../components/CustomButtons/Button.js";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import { ReactComponent as NoCardIcon } from "../../assets/img/icon_add_a_card.svg"
import { primaryColor, primaryIconColor } from "../../style.scss"
import formStyle from "../../assets/jss/eclipse/components/formStyle.js";
import TextField from '@material-ui/core/TextField';
import Danger from "../../components/Typography/Danger.js";
import { DCustomerManagementApi } from "eclipse-react-sdk/services";
import { SpinnerComponent } from "react-element-spinner";
import AlertNotification from "../../components/Snackbar/AlertNotification.js";
import { AuthQueryParamWithTemplateId } from "../../default-route.js";
import { loginToApp } from "../../redux-services/actions/actions.js";
import { ToBinary } from "../../utils.js";

const useStyles = makeStyles(themeStyle);
const ValidationTextField = withStyles(formStyle)(TextField);


export function CardOnFile(props) {
  const pageState = useLocation().state;
  const fromScreen = pageState?.fromScreen;
  const history = useHistory();
  const classes = useStyles();
  const [isLoading, setLoading] = React.useState(false);
  const [alertData, setAlert] = React.useState(null);
  const [inputs, setInputs] = useState({ alias: '' });
  const [errors, setErrors] = useState({});

  const handleInputChange = (event) => {
    event.persist();
    inputs[event.target.name] = event.target.value;
    setInputs(inputs);
    const validationErrors = validateCardForm(inputs);
    setErrors(validationErrors);
  }

  const returnScreenName = (screenCode) => {
    switch (screenCode) {
      case 'BUYAIRTIMEDATA': 
        return 'Airtime Data';
      case 'BUYELECTRICITY':
        return 'Electricity';
      case 'AIRTIMEDATA':
        return 'Airtime Data';
      case 'COLLECTIONS':
        return 'Collections';
      case 'VAS':
        return 'Buy';
      case 'PAYBILL':
        return 'Pay Bill';
      case 'TOPUP':
        return 'Top-up';
      case 'PAY-PAYSHAP-AMOUNT':
        return 'Top-up';
      case 'MANAGE-CARDS':
        return 'My Cards';
      case 'QRSCAN':
        return 'Scan QR';
      default:
        return 'Home';
    }
  }

  const goToBack = useCallback(() => {
    if (fromScreen === 'AIRTIMEDATA' || fromScreen === 'BUYAIRTIMEDATA' || fromScreen === 'BUYELECTRICITY') {
      history.push({
        pathname: '/pages/vas-buy-airtime-data',
        state: { ...pageState }
      });
    } else if (fromScreen === 'COLLECTIONS') {
      history.push({
        pathname: '/pages/vas-buy-kganya-products',
        state: { ...pageState }
      });
    } else if (fromScreen === 'PAYBILL') {
      history.push({
        pathname: '/pages/vas-pay-bill',
        state: { ...pageState }
      });
    } else if (fromScreen === 'QRSCAN') {
      history.push({
        pathname: '/pages/pay-amount',
        state: { ...pageState }
      });
    } else if (fromScreen === 'TOPUP') {
      history.push({
        pathname: '/pages/topup',
        state: { ...pageState }
      });
    } else if (fromScreen === 'MANAGE-CARDS') {
      history.push({
        pathname: '/pages/manage-linked-cards',
        state: { ...pageState }
      });
    } else if(fromScreen ==="PAY-PAYSHAP-AMOUNT"){
      history.push({
        pathname: '/pages/topup',
        state: { ...pageState }
      });
    } else {
      const appData = {
        ...props?.appData,
        isRefresh: true
      }
      props.cardOnFileHandler(appData);
      history.push({
        pathname: '/pages/dashboard'
      });
    }
  }, [fromScreen, history, props, pageState]);

  React.useEffect(() => {
    return () => {
      window.onpopstate = () => {
        goToBack();
      }
    };
  }, [goToBack])

  const handleInputKeyUp = (event) => {
    event.persist();
    const validationErrors = validateCardForm(inputs);
    setErrors(validationErrors);
  }

  const validateCardForm = (inputs) => {
    const errors = {}

    if (!inputs.alias) {
      errors.alias = 'Card name is required!'
    } else if (!/^[A-Za-z0-9]+[ A-Za-z0-9]{1,}$/i.test(inputs.alias)) {
      errors.alias = 'Invalid card name!'
    } else if (inputs?.alias?.length > 50) {
      errors.alias = 'Invalid card name! Its length should be a maximum of 50.'
    }

    return errors
  }

  const showAlert = (alertDisplay, alertType, message) => {
    setAlert({ isAlertDisplay: alertDisplay, alertType: alertType, alertMessage: message })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  const redirectToErrorScreen = useCallback((fromScreen, toScreen) => {
    history.push({
      pathname: toScreen,
      state: { fromScreen: fromScreen }
    });
  }, [history]);

  const addCardsOnFile = useCallback((cardAlias) => {
    setLoading(true);
    const customerLinkedBankCardsAPI = new DCustomerManagementApi();
    const cardRequestBody = {
      alias: cardAlias,
      landingUrl: `${window.location.origin}${process.env.PUBLIC_URL}/pages/success-link-card${AuthQueryParamWithTemplateId() ? AuthQueryParamWithTemplateId() : ''}`
    }
    customerLinkedBankCardsAPI.tenantsTenantIdCustomersCustomerIdCardsOnFilePost(props?.appData?.auth?.tenantId, props?.appData?.customer?.customerId, cardRequestBody).then((customerLinkedBankCardsAPIResponse) => {
      setLoading(false);
      if (customerLinkedBankCardsAPIResponse.data && customerLinkedBankCardsAPIResponse.data?.cardOnFileId && customerLinkedBankCardsAPIResponse.data?.completionUrl) {
        window.localStorage.setItem('appstate', btoa(ToBinary(JSON.stringify({ ...props?.appData, pageState }))));
        window.location.replace(customerLinkedBankCardsAPIResponse.data?.completionUrl);
      } else {
        showAlert(true, 'ERROR', `Something went wrong. Please try again!`);
      }
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/dashboard', '/pages/error');
      }
    });
  }, [props, redirectToErrorScreen, pageState]);

  const handleCardFormSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validateCardForm(inputs);
    const noErrors = Object.keys(validationErrors).length === 0;
    setErrors(validationErrors);
    if (noErrors) {
      addCardsOnFile(inputs?.alias);
    }
  }

  return (
    <div>
      <SpinnerComponent loading={isLoading} position="global" color={primaryColor} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <form onSubmit={handleCardFormSubmit}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center', marginTop: '20px' }}>
                <NoCardIcon stroke={primaryIconColor} fill={primaryIconColor} />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <h5 className={classes.textCenter + ' m-t-0'}><b>Give your bank card a name</b></h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <ValidationTextField
                  fullWidth
                  label="Card name"
                  variant="filled"
                  id="alias"
                  type="text"
                  error={(errors.alias) ? true : false}
                  name="alias"
                  value={inputs.alias}
                  onChange={handleInputChange}
                  onKeyUp={handleInputKeyUp} />
                {errors.alias && <Danger><small>{errors.alias}</small></Danger>}
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={6} sm={6} md={6} style={{ marginTop: '10px' }}>
                <Button className={classes.buttonRadius} size="lg" block color="transparent" type="button" onClick={goToBack} >Back {fromScreen ? 'to ' + returnScreenName(fromScreen) : ''}</Button>
              </GridItem>
              <GridItem xs={6} sm={6} md={6} style={{ marginTop: '10px' }}>
                <Button className={classes.buttonRadius} size="lg" block color="primary" type="submit" disabled={(errors.alias) ? true : false}>Next</Button>
              </GridItem>
            </GridContainer>
          </form>
        </GridItem>
      </GridContainer>
      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData} /> : null}
    </div>
  )
}


const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

const mapDispatchToProps = dispatch => ({
  cardOnFileHandler: data => dispatch(loginToApp(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(CardOnFile)